import * as Yup from 'yup';

import { firstNameValidationSchema, lastNameValidationSchema } from '~/common/utils/validation';

import { CHECKBOX_TERMS_NAME } from '../constants';

const passwordValidationMessage =
  'Password must be at least 8 characters long, contain one upper case letter, and one symbol';

export const passwordSchema = Yup.string()
  .min(8, passwordValidationMessage)
  .matches(/[A-Z]/, passwordValidationMessage)
  .matches(/[.!@?#"$%&:';()*+,\-=[\]^_{|}<>~±§`/\\]/, passwordValidationMessage)
  .required(passwordValidationMessage);

export const emailSignUpSchema = Yup.object().shape({
  checkboxOptions: Yup.array()
    .of(Yup.string().required())
    .test('required-validation', 'Please accept terms and conditions', (value) => {
      if (!value || !Array.isArray(value)) {
        return false;
      }
      return value.includes(CHECKBOX_TERMS_NAME);
    }),
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Please enter a valid email address'),
  firstName: firstNameValidationSchema,
  lastName: lastNameValidationSchema,
  password: passwordSchema,
});
